export const FilterSectionTypes = {
    consultants: "consultants",
    costHeading: "costHeading",
    organisations: "organisations",
    outcome: "outcome",
    planningStatus: "planningStatus",
    products: "products",
    projects: "projects",
    status: "status",
};

// Use only organisation slugs to get the new filter menu items.
export const filterSectionTypesForFilterMenuRequest = (type) => {
    switch (type) {
        case FilterSectionTypes.organisations:
            return "organisation";
        default:
            return null;
    }
};

export const filterSectionTypesForParticipantsRequest = (type, permissionStatus) => {
    switch (type) {
        case FilterSectionTypes.organisations:
            return "project.organisation";
        case FilterSectionTypes.products:
            return "product";
        case FilterSectionTypes.projects:
            return "project";
        case FilterSectionTypes.consultants:
            return "consultant";
        case FilterSectionTypes.costHeading:
            return "costHeading";
        case FilterSectionTypes.status:
            if (permissionStatus) {
                return "reportBase.reportPermissions.status";
            }
            return "accountHasRole.genericRoleStatus";
        case FilterSectionTypes.planningStatus:
            return "planningStatus";
        case FilterSectionTypes.outcome:
            return "outcome";
        default:
            return null;
    }
};
